const records = 'purchase-orders';
const items = 'purchase-order-items';
const shipMethods = 'ship-methods';
const receivers = 'purchase-order-receivers';

export default {
  records,
  items,
  shipMethods,
  receivers,
};
